import { Card, Dimmer, Loader, Segment } from 'semantic-ui-react';

import { useAppContext } from '../../Contexts/AppContext';
import { getPreferredTabForFeature } from '../../Menu/menuConfig';
import ErrorMessage from '../ErrorMessage';
import SelectItem from './SelectItem';

const FEATURE_CARDS = [
    {
        feature: 'shipping',
        icon: 'box',
        header: 'Shipping',
        subheader: 'Request shipping label for repair',
    },
    {
        feature: 'protectionPlan',
        icon: 'shield',
        header: 'Protection Plan',
        subheader: 'Register protection plan for sales product',
    },
    {
        feature: 'gen1',
        icon: 'truck',
        header: 'Gen1',
        subheader: 'Order Gen1 Trunking',
    },
];

export default function ComponentSelect() {
    const { Reducer } = useAppContext();

    let errorMessage = null;
    if (
        Reducer.masterDataIsLoadingError ||
        Reducer.logoutingError ||
        Reducer.manualDownloadingError
    ) {
        errorMessage = (
            <ErrorMessage content={Reducer.errorMessage} active page />
        );
    }

    const cardItems = FEATURE_CARDS.map((item) => ({
        ...item,
        tabStatus: getPreferredTabForFeature(
            Reducer.userInformation,
            item.feature
        ),
    })).filter((item) => item.tabStatus);

    return (
        <>
            {errorMessage}
            <Segment placeholder basic>
                <Card.Group centered>
                    {cardItems.map((item) => {
                        return (
                            <SelectItem
                                key={item.feature}
                                icon={item.icon}
                                header={item.header}
                                subheader={item.subheader}
                                nextTabStatus={item.tabStatus}
                            />
                        );
                    })}
                </Card.Group>
            </Segment>
            <Dimmer
                active={
                    Reducer.masterDataIsLoading ||
                    Reducer.fileDownloading ||
                    Reducer.customerAddressBookFetching
                }
                page
            >
                <Loader content="Loading..." size="huge"></Loader>
            </Dimmer>
        </>
    );
}
